import { levelUpSettingsEntryPoint } from '@jira/project-settings__level-up-settings/src/levelUpSettingsEntryPoint.tsx';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const projectDetailsPageEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-project-details-page-entrypoint" */ './ProjectDetailsPage.tsx'
			),
	),
	// @TODO: fix once https://product-fabric.atlassian.net/browse/AFB-1544 is resolved
	// @ts-expect-error TS2345 - TypeScript can't properly infer nested entrypoints type, levelUpSettingsEntryPoint is inferred as 'never'
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {},
		entryPoints: {
			preloadedLevelUpSettingsEntryPoint: {
				entryPoint: levelUpSettingsEntryPoint,
				entryPointParams: {
					context,
					tenantContext,
				},
			},
		},
		extraProps: {},
	}),
});
